export default __webpack_public_path__ + "a753508c7267368fbed975d3c12bd6d9.svg";